module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [(this.isManager()) ? _c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": "",
      "disabled": _vm.isViewOnly()
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b693da2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/controls/ContactControls.vue
// module id = 1315
// module chunks = 0